import { parseDateHeader } from './customer-revenue-report-calculations';

const MIN_DATE = new Date(-8640000000000000);
const MAX_DATE = new Date(8640000000000000);

function toMonthStart(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function filterDateHeaders(
  allDateHeaders: string[],
  fromDate?: Date | null,
  recognizedUpTo?: Date | null,
): string[] {
  const rangeStart = fromDate ? toMonthStart(fromDate) : MIN_DATE;
  const rangeEnd = recognizedUpTo ? toMonthStart(recognizedUpTo) : MAX_DATE;

  return allDateHeaders.filter((header) => {
    const headerDate = parseDateHeader(header);
    return headerDate >= rangeStart && headerDate <= rangeEnd;
  });
}
